<template>
  <div v-if="create || net._id">
    <div class="container text-left">
      <div class="row">
        <div class="col-lg-12">
          <BreadcrumbsHelper class="sn-bread" :breadcrumbs="this.Breadcrumbs" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 mt-2">
          <b-card>
            <div class="row">
              <div class="col-lg-6">
                <h1 v-if="create" class="title">Untitled Social Media</h1>
                <h1 v-else class="title">{{ net.name }}</h1>
              </div>
              <div class="col-lg-6 text-right">
                <button v-if="!create" @click="deleteSocialNetwork()" class="btn btn-white delete">Delete</button>
              </div>
            </div>
            <b-form @submit.prevent="onSubmit">
              <div class="card-info row">
                <div class="col-lg-12">
                  <b-form-group label="Social Media Title (Required)" label-for="netName">
                    <b-form-input id="netName" v-model="net.name" placeholder="Social Media Title" type="text" :state="submitted && $v.net.name.$error ? false : null" />
                    <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.net.name.required">
                      <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a title
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="Base Url (Required)" label-for="baseUrl">
                    <b-form-input id="baseUrl" v-model="net.base_url" placeholder="https://example.com" />
                    <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.net.base_url.required">
                      <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a base url
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="Logo (Required)" label-for="logo">
                    <img
                      v-if="!create && net.image !== ''"
                      class="logo"
                      :src="`https://alabama-travel.s3.amazonaws.com/partners-uploads/social_network/image/${net._id}/${net.image}`"
                    />
                    <logo v-on:updateFiles="updateLogos" @isNowValid="isValid($event)" ref="logoUpload" />
                  </b-form-group>
                  <b-form-invalid-feedback class="d-block red" v-if="submitted && logoStatus === false">
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please upload a logo
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback class="final-alert d-block" v-if="submitted && (this.$v.$invalid || logoStatus === false)">
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />
                    <span aria-live="polite" class="validation-message">Double check the required fields. We don't have everything we need to save the record.</span>
                  </b-form-invalid-feedback>
                  <div class="save-button">
                    <b-button type="submit" @click="saveBtn($event)" :disabled="submitted && $v.$invalid">Save</b-button>
                  </div>
                </div>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
import logo from '../../components/Logo.vue';
import stateList from '../../assets/state-list.json';
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    logo,
    BreadcrumbsHelper,
  },
  data() {
    return {
      net: {
        name: '',
        base_url: '',
        image: '',
      },
      Breadcrumbs: [
        {
          text: 'Settings',
          active: true,
        },
        {
          text: 'Social Networks',
          href: '/social-networks',
        },
        {
          text: '',
          active: true,
        },
      ],
      logoStatus: false,
      logoImageName: null,
      submitted: false,
      stateOptions: stateList,
      loaded: false,
    };
  },
  validations: {
    net: {
      name: {
        required,
      },
      base_url: {
        required,
      },
    },
  },
  props: {
    netId: String,
    create: Boolean,
  },
  async created() {
    if (!this.create) {
      let net = this.$store.getters['misc/getNetById'](this.netId);
      this.loaded = true;
      if (this.loaded) {
        this.Breadcrumbs[2].text = `${net.name} Edit`;
      }
      if (!net) {
        await this.$store.dispatch('misc/getSocialNetworks', this.netId);
        net = this.$store.getters['misc/getNetById'](this.netId);
      }
      this.net = { ...this.net, ...net };
    } else if (this.create) {
      this.Breadcrumbs[2].text = 'New Network';
    }
  },
  methods: {
    async onSubmit() {
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }
      if (this.net.image) {
        this.logoStatus = true;
      }
      const url = this.create ? `${process.env.VUE_APP_API_ROOT}/misc/socialNetworks` : `${process.env.VUE_APP_API_ROOT}/misc/socialNetworks/${this.netId}`;
      const regEx = /(http(s?)):\/\//i;
      if (this.net.base_url && !regEx.test(this.net.base_url)) {
        const message = 'Website URL must include http:// or https://';
        this.$bvToast.toast(message, {
          title: 'Error',
          autoHideDelay: 8000,
          appendToast: true,
        });
        this.isLoading = false;
        return;
      }
      if (this.logoStatus === false) {
        const message = 'Please upload a logo';
        this.$bvToast.toast(message, {
          title: 'Error',
          autoHideDelay: 8000,
          appendToast: true,
        });
        this.isLoading = false;
        return;
      }
      try {
        const updateNetwork = await axios.post(url, this.net);
        if (updateNetwork.data.errmsg) {
          this.$bvToast.toast(JSON.stringify(updateNetwork.data.errmsg), {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: false,
          });
        } else {
          await this.$refs.logoUpload.uploadFiles(updateNetwork.data._id);
          if (this.logoImageName && this.logoImageName[0] && this.logoImageName[0].imageName) {
            updateNetwork.data.image = this.logoImageName[0].imageName;

            const updateUrl = this.create ? `${url}/${updateNetwork.data._id}` : url;

            const updateLogoName = await axios.post(updateUrl, updateNetwork.data);
            if (updateLogoName.data.errmsg) {
              this.$bvToast.toast(JSON.stringify(updateLogoName.data.errmsg), {
                title: 'Error',
                autoHideDelay: 5000,
                appendToast: false,
              });
            } else {
              const self = this;
              this.$store.commit('misc/updateNet', this.net);
              this.$router.push('/social-networks', () => {
                setTimeout(() => {
                  self.$bvToast.toast('Network Updated', { title: 'Success', autoHideDelay: 5000, appendToast: true });
                }, 500);
              });
            }
          } else if (updateNetwork.data.image) {
            const self = this;
            this.$store.commit('misc/updateNet', this.net);
            this.$router.push('/social-networks', () => {
              setTimeout(() => {
                self.$bvToast.toast('Network Updated', { title: 'Success', autoHideDelay: 5000, appendToast: true });
              }, 500);
            });
          } else {
            console.log('Error Updating Image Name'); // DO NOT DELETE
          }
        }
      } catch (err) {
        this.$bvToast.toast('Something went wrong.', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: false,
        });
      }
    },
    isValid(logoStatus) {
      this.logoStatus = logoStatus;
    },
    saveBtn(event) {
      if (!this.$v.$invalid && this.logoStatus) {
        event.target.innerText = 'Saving...';
      }
    },
    async deleteSocialNetwork() {
      const response = await axios.delete(`${process.env.VUE_APP_API_ROOT}/misc/socialNetworks/${this.netId}`);
      this.net = response.data;
      if (response.status === 200) {
        const self = this;
        this.$router.push('/social-networks', () => {
          setTimeout(() => {
            self.$bvToast.toast('Network Deleted', { title: 'Success', autoHideDelay: 5000, appendToast: true });
          }, 500);
        });
      } else {
        this.$bvToast.toast(JSON.parse(response.data).message, {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }
    },
    updateLogos(logoFile) {
      this.logoImageName = logoFile;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: none;
}
.card-body h1 {
  margin: 0px !important;
  line-height: 4rem;
}
div.image-desc {
  width: 60%;
  font-size: 14px;
}
.final-alert {
  padding-top: 10px;
}
.invalid-feedback {
  color: black;
}
.logo {
  height: 200px;
  margin: 30px 0px 50px;
  width: 200px;
}
.validation-message {
  position: absolute;
}
</style>
